import React, { useRef } from 'react'

import { FaFileImport } from 'react-icons/fa'
import { IconContext } from 'react-icons'
import { LoaderButton } from '../../../../../_components/LoaderButton'
import { UploadBlockerModal } from '../../../../../_components/modals/scheduleInvoices/UploadBlockerModal'
import { UploadResults } from '../../../../ClientViews/UploadInvoices/UploadResults'
import { isLender } from '../../../../../_helpers/user-utils'
import { store } from '../../../../../_helpers'
import { uploadInvoiceSchedule } from '../../../../../_services/invoices.service'
import { useModal } from '../../../../../_reduxHooks/modal.hook'
import { useScheduleInvoices } from '../../../../../_reduxHooks/scheduleInvoices.hook'

export const UploadInvoicesButton = ({
  scheduleId,
  setLoading,
  reloadSchedulePage,
  isLoading,
  disabled,
  refreshInvoicesTable,
  setTotalInvoices,
}) => {
  const fileInput = useRef(null)
  const { openModal } = useModal()
  const { user, authentication } = store.getState()
  const isLenderUser = isLender(authentication?.loggedIn, user.user_type)

  const { setUploadShouldNotify } = useScheduleInvoices()
  const showBlockerModal = () => {
    openModal(
      UploadBlockerModal,
      { isLender: isLenderUser },
      { modalTitle: 'Your Invoices Are Being Uploaded', titleAlign: 'center' }
    )
  }

  const uploadWithTimeout = async (file) => {
    const timeoutFlag = 'timeout'
    const duration = 10000

    let waitForPurchase = new Promise((resolve) => {
      let timeout = setTimeout(() => {
        clearTimeout(timeout)
        resolve(timeoutFlag)
      }, duration)
    })

    let race = Promise.race([waitForPurchase, uploadInvoiceSchedule(file, scheduleId)])

    race
      .then((e) => {
        if (e === timeoutFlag) {
          setUploadShouldNotify(true)
          showBlockerModal(isLender)
        } else {
          setUploadShouldNotify(false)
          openModal(UploadResults, {
            successCount: e.success_count,
            errors: e.errors,
            warnings: e.warnings,
          })
          refreshInvoicesTable()
          reloadSchedulePage()
          setTotalInvoices(e.success_count)
          setLoading(false)
        }
      })
      .catch((error) => {
        openModal(UploadResults, {
          successCount: 0,
          errors: [],
          warnings: [],
          templateError: error,
        })
        setLoading(false)
      })
  }

  return (
    <>
      <input
        accept=".xlsx, .csv"
        onChange={() => {
          setLoading(true)
          // Prevent firing if no file found
          if (!fileInput.current.files || !fileInput.current.files.length) {
            return
          }
          uploadWithTimeout(fileInput.current.files[0])
        }}
        onClick={(e) => {
          e.target.value = null
        }}
        ref={fileInput}
        style={{ display: 'none' }}
        type="file"
      />
      <LoaderButton
        className={`table-controls-btn compact`}
        disabled={disabled}
        isLoading={isLoading}
        onClick={() => {
          fileInput.current.click()
        }}
      >
        <IconContext.Provider value={{ size: '16px', className: 'add-icon' }}>
          <FaFileImport />
        </IconContext.Provider>
        Upload Invoices
      </LoaderButton>
    </>
  )
}
